import { Component, OnInit } from '@angular/core';
import { FaqPublicService } from '../service/faq-public.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-faq-public',
  templateUrl: './faq-public.component.html',
  styleUrls: ['./faq-public.component.css']
})
export class FaqPublicComponent implements OnInit {
  faqs: any;
  LANG: string;

  constructor( private dataApi: FaqPublicService, private translate: TranslateService,
               private spinner: NgxSpinnerService,
               private _snackBar: MatSnackBar, public dialog: MatDialog) {
  }
  ngOnInit() {
    this.spinner.show("loading");
    this.dataApi.getallfaq().subscribe(data=>{




      this.faqs = data;
      this.spinner.hide("loading");
    },
                                       (err) => {
                                         this.spinner.hide("loading");
                                         if(err.error.error !== 'Invalid token.') {
                                          this.dialog.open(ModErrorComponent, {
                                            width: 'auto',
                                            panelClass: 'myapp-no-padding-dialog',
                                          });
                                        }
                                       });
  }

  getlang(){
    return sessionStorage.getItem('lang');
  }


}
